import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';


import './slider.css';
import '../../../../../grid.css';

export default class YearSlider extends React.Component {
    static propTypes = {
        doughnutSlider: PropTypes.number.isRequired,
        setYearSliderChange: PropTypes.func.isRequired,
        horizonLength: PropTypes.number.isRequired,
    };


    handlePieSliderChange(value) {
        const { setYearSliderChange } = this.props;
        setYearSliderChange(value);
    }

    handleAddYear() {
        const { doughnutSlider, horizonLength, setYearSliderChange } = this.props;
        const sliderValue = doughnutSlider > horizonLength ? 1 : doughnutSlider;
        const add = sliderValue + 1;
        setYearSliderChange(add);
    }
    handleRemoveYear() {
        const { doughnutSlider, horizonLength, setYearSliderChange } = this.props;
        const sliderValue = doughnutSlider > horizonLength ? 1 : doughnutSlider;
        const remove = sliderValue - 1;
        setYearSliderChange(remove);
    }
    handleResetYear() {
        const { setYearSliderChange } = this.props;
        setYearSliderChange(1);
    }


    render() {
        const { doughnutSlider, horizonLength } = this.props;

        const sliderValue = doughnutSlider > horizonLength ? 1 : doughnutSlider;

        return (
            <div className="buttons-container">
                {sliderValue > 1 ?
                    <Button onClick={() => this.handleResetYear()}>reset</Button>
                    : <Button>reset</Button>}
                {sliderValue > 1 ?
                    <Button onClick={() => this.handleRemoveYear()}>remove year</Button>
                    : <Button>remove year</Button>}
                {sliderValue < 30 ?
                    <Button onClick={() => this.handleAddYear()}>add year</Button>
                    : <Button>add year</Button>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/YearSlider/YearSlider.js